import { GridAggregationFunction, GridColumnsInitialState } from '@mui/x-data-grid-premium';
import { Column } from '../../../../../../shared/components/table/components/common.components.tsx';
import { localeFormatterHelper } from '../../../../../../shared/helpers/formatter/localeFormatter.helper.ts';
import { ComparisonCell } from './comparison.cell.tsx';
import { ComparisonFooterLegend } from './comparisonLegend.tsx';
import {
  buildComparisonKey,
  COMPARISON_FIELD_PREFIX,
  COMPARISON_HEADER_BG,
  IComparisonMetricsByKey,
  MAX_COMPARISON_DATES,
} from './comparison.types.ts';

export const comparisonGridSx = {
  '& .comparison-col-header': { backgroundColor: COMPARISON_HEADER_BG },
  '& .MuiDataGrid-pinnedRows--bottom': { boxShadow: 'none' },
  '& .MuiDataGrid-pinnedRows--bottom, & .MuiDataGrid-pinnedRows--bottom .MuiDataGrid-row, & .MuiDataGrid-pinnedRows--bottom .MuiDataGrid-cell':
    {
      minHeight: '52px !important',
      maxHeight: '52px !important',
    },
  '& .MuiDataGrid-pinnedRows--bottom .MuiDataGrid-cell': {
    borderTop: '1px solid',
    borderTopColor: 'grey.300',
  },
  '& .MuiDataGrid-pinnedRows--bottom .comparison-col-cell': {
    backgroundColor: `${COMPARISON_HEADER_BG} !important`,
    backgroundImage: 'none !important',
  },
};

export const generateComparisonColumns = (
  dates: string[],
  metricsByKey: IComparisonMetricsByKey,
  customerId?: string,
) => {
  return dates.map((date, i) => (
    <Column
      key={`${COMPARISON_FIELD_PREFIX}${i}`}
      field={`${COMPARISON_FIELD_PREFIX}${i}`}
      headerName={localeFormatterHelper.formatDate(date)}
      headerClassName='comparison-col-header'
      cellClassName='comparison-col-cell'
      headerAlign='center'
      align='center'
      width={160}
      sortable={false}
      disableReorder
      valueGetter={(_, row) => metricsByKey[buildComparisonKey(customerId, date, row?.articleId)]}
      renderCell={(params) =>
        params.aggregation ? (
          i === 0 ? (
            <ComparisonFooterLegend />
          ) : null
        ) : (
          <ComparisonCell value={params.value} date={date} row={params.row} />
        )
      }
    />
  ));
};

export const getComparisonLegendAggregation = (): GridAggregationFunction<unknown, string> => ({
  apply: () => '',
  label: '',
  columnTypes: ['string', 'number'],
});

export const attachComparisonToColumns = (
  model?: GridColumnsInitialState,
): GridColumnsInitialState | undefined => {
  if (model?.orderedFields) {
    model.orderedFields = model.orderedFields.filter(
      (el: string) => !el.includes(COMPARISON_FIELD_PREFIX),
    );
    const comparisonFields = Array.from(
      { length: MAX_COMPARISON_DATES },
      (_, i) => `${COMPARISON_FIELD_PREFIX}${i}`,
    );
    const deletingIdx = model.orderedFields.findIndex((el: string) => el === 'deleting');
    if (deletingIdx > -1) {
      model.orderedFields.splice(deletingIdx, 0, ...comparisonFields);
    } else {
      model.orderedFields.push(...comparisonFields);
    }
  }
  return model;
};
